// Maps each purchasable subscription tier to its Shopify variant + the Seal
// selling plans (monthly + annual), for the admin-only in-app checkout (beta).
// This is the parallel path to the public "link out to the store page" flow —
// keeping the mapping in its own file avoids touching the shared plan config in
// src/lib/authz/plans.ts.
//
// `variantId` mirrors PLAN_TIER_BY_VARIANT_ID in src/lib/authz/plans.ts.
// `sellingPlanByBilling` are the native Shopify selling plan ids (numeric, as
// Seal/Shopify expose them) for the monthly and yearly billing options. Fetched
// from the product's sellingPlanGroups for product "The Workshop V2".

import type { PlanTier } from "@/lib/authz/plans";

export type SubscriptionCheckoutPlan = {
  variantId: string;
  sellingPlanByBilling: {
    monthly: string;
    annual: string;
  };
};

export const SUBSCRIPTION_CHECKOUT_PLANS: Partial<Record<PlanTier, SubscriptionCheckoutPlan>> = {
  vehicle_dev: {
    variantId: "51995955102016",
    sellingPlanByBilling: { monthly: "693623226688", annual: "693623259456" },
  },
  server_dev: {
    variantId: "51995955167552",
    sellingPlanByBilling: { monthly: "693623292224", annual: "693623324992" },
  },
  all_services: {
    variantId: "51995955200320",
    sellingPlanByBilling: { monthly: "693623357760", annual: "693623390528" },
  },
  studio: {
    variantId: "51995969585472",
    sellingPlanByBilling: { monthly: "693623423296", annual: "693623456064" },
  },
};

// Tiers an admin can start a checkout for (insertion-ordered).
export const SUBSCRIPTION_CHECKOUT_TIERS = Object.keys(
  SUBSCRIPTION_CHECKOUT_PLANS,
) as PlanTier[];
